export const packageOfferSelection = (selection = {}) => ({
	optionIds: Array.isArray(selection.optionIds) ? [...selection.optionIds] : [],
	addOns: Array.isArray(selection.addOns) ? selection.addOns.filter(Boolean).map((addOn) => ({ addOnId: addOn.addOnId, quantity: addOn.quantity })) : [],
	paymentChoiceId: selection.paymentChoiceId || null,
});

export const isDecimalAmount = (money) => Boolean(money && typeof money.amount === 'string' && typeof money.currency === 'string' && /^-?\d+(?:\.\d+)?$/.test(money.amount));

export const isDecimalZero = (money) => isDecimalAmount(money) && /^-?0+(?:\.0+)?$/.test(money.amount);

export const clampQuantity = (value, rules = {}) => {
	const minimum = Number.isFinite(Number(rules.minimum)) ? Math.max(1, Number(rules.minimum)) : 1;
	const maximum = Number.isFinite(Number(rules.maximum)) ? Math.max(minimum, Number(rules.maximum)) : minimum;
	const step = Number(rules.step) > 0 ? Number(rules.step) : 1;
	const requested = Number.isFinite(Number(value)) ? Number(value) : minimum;
	const clamped = Math.min(maximum, Math.max(minimum, requested));
	const steps = Math.min(Math.floor((maximum - minimum) / step), Math.max(0, Math.round((clamped - minimum) / step)));
	return Number((minimum + steps * step).toFixed(10));
};
